import * as React from "react";
import {cx} from "emotion";

import "./change-template-modal.scss";

import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {keyed}                          from "@Common/react/keyed";
import {UseState}                       from "@Common/react/use-state";
import {isDevQuan}                      from "@Common/ui-components/debug/is-dev-quan";
import {ModalService3}                  from "@Common/ui-components/modal-service-3/modal-service-3";
import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {omit, values}                   from "@Common/utils/objects";

import {GridView} from "./grid-view/grid-view";
import {ListView} from "./list-view/list-view";

export const ChangeTemplateModal = ({productLabel, templates, programPrefs, store, next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        // initShow: true,
        contentService: ({params, close, next: next1}) => next({
            params, close,
            next: next1,
        }),
        rootNext,
    })],
    consumeContext("apis"),
    ["listMode", (_, next) => UseState({
        // initValue: isDevQuan(),
        next,
    })],
    ["defaultId", ({modal}, next) => next(getNestedValue(programPrefs, modal.params.path))],
    ["selectedId", ({modal}, next) => cs(
        ["selectedId", ({}, next) => next(getNestedValue(store.prefs , modal.params.path))],
        ["state", ({selectedId}, next) => UseState({initValue: selectedId, next})],
        ({state}) => next(state),
    )],
    ({modal, listMode, selectedId, defaultId, apis}) => modal.next({
        width: listMode.value ? 478 : 1108,
        content: (
            <div className="change-template-modal-421">
                <div className="header">
                    <div className="left">
                        <div
                            className="title"
                            xd-qa-type="label" xd-qa-name={`Choose ${productLabel}`}
                        >
                            Choose {productLabel}
                        </div>
                        <div className="sub-title">
                            {modal.params.triggerLabel}
                        </div>
                    </div>

                    <div className="right">
                        <button
                            className={cx({active: !listMode.value})}
                            onClick={() => listMode.onChange(false)}
                        >
                            <i className={cx("fa fa-th-large", )}/>
                        </button>
                        <div className="divider"/>
                        <button
                            className={cx({active: listMode.value})}
                            onClick={() => listMode.onChange(true)}
                        >
                            <i className={cx("fa fa-th-list", )}/>
                        </button>
                    </div>
                </div>

                {cs(
                    keyed(listMode.value),
                    () => (
                        listMode.value ? (
                            ListView
                        ) : (
                            GridView
                        )
                    )({
                        items: templates?.map((template) => ({
                            key: template.id,
                            isDefault: defaultId  == template.id,
                            selected: template.id == selectedId.value,
                            img: values(template.images)?.[0]?.url,
                            label: `${template.name} (01)(${template.id},8) ***`,
                            onClick: () => selectedId.onChange(template.id),
                        })),
                    })
                )}

                <div className="footer">
                    <button
                        className="cancel"
                        onClick={modal.close}
                    >
                        Cancel
                    </button>
                    {cs(
                        ["submitting", (_, next) => UseState({next})],
                        ({submitting}) => (
                            <button
                                className="next"
                                disabled={submitting.value}
                                onClick={async () => {
                                    try {
                                        submitting.onChange(true);
                                        await store.dispatch(changeTemplateId(
                                            selectedId.value,
                                            {
                                                path: modal.params.path,
                                                apis,
                                            }
                                        ));
                                        modal.close();
                                    } finally {
                                        submitting.onChange(false);
                                    }
                                }}
                            >
                                {submitting.value ? <>
                                    Saving...{" "}
                                    <i className="fa fa-spinner fa-pulse"/>
                                </> : (
                                    "Use Selected Template"
                                )}
                            </button>
                        )
                    )}
                </div>
            </div>
        ),
    }),
);

const changeTemplateId = (templateId, {path, apis,}) => ({
    action: async (prefs) => {
        const newPrefs = setNestedValue(
            omit(prefs, ["error"]),
            path,
            templateId,
        );
        await apis.listings.saveCleanUserPrefs(newPrefs);
        return {
            change: () => newPrefs,
        };
    },
});